import { useEffect } from "react";
import { useFetcher } from "react-router";

import { getProductRecommendations } from "~/lib/product-recommendations";

export const loader = async ({ request, context }: LoaderArgs) => {
  const url = new URL(request.url);
  const sysId = url.searchParams.get("sysId");
  const categoryId = url.searchParams.get("categoryId") ?? undefined;
  const productIDs = url.searchParams.get("productIDs") ?? undefined;
  const { api } = context;

  if (!sysId) {
    return null;
  }

  const recommendations = await getProductRecommendations({
    sysId,
    categoryId,
    productIDs: productIDs?.split(","),
    api,
  });

  return { recommendations };
};

export const useProductRecommendations = ({
  sysId,
  categoryId,
  productIDs,
}: {
  sysId: string;
  categoryId?: string;
  productIDs?: string[];
}) => {
  const fetcher = useFetcher<typeof loader>();
  const isLoading = fetcher.state !== "idle" && fetcher.data === undefined;

  useEffect(() => {
    const searchParams = new URLSearchParams();
    if (!sysId) {
      return;
    }
    searchParams.set("sysId", sysId);
    if (categoryId) {
      searchParams.set("categoryId", categoryId);
    } else if (Array.isArray(productIDs) && productIDs.length > 0) {
      searchParams.set("productIDs", productIDs.join(","));
    }
    fetcher.load(
      `/resources/product-recommendations?${searchParams.toString()}`,
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId, ...(productIDs ?? []), sysId]);

  return { data: fetcher.data, isLoading, fetcher };
};
